/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import CustomerLink from '../customer/CustomerLink'
import Amount from '../transaction/Amount'
import { getTransactionLink } from '../../lib/links/transactionLinks'
import TransactionStatusBadge from '../transaction/TransactionStatusBadge'
import { getInvoiceLink } from '../../lib/links/invoiceLinks'
import { getLeaseLink } from '../../lib/links/leaseLinks'
import { ActionIcon, Table, TableProps } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons/faMinusSquare'
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons/faPlusSquare'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'

export type PaymentListItemProps = TableProps & {
  payment: Payment,
}

function PaymentListItem (props: PaymentListItemProps) {
  const {
    payment,
    ...others
  } = props

  const intl = useIntl()
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const toggle = useCallback(() => {
    setIsExpanded((s) => !s)
  }, [])

  return (
    <Table
      highlightOnHover
      {...others}
    >
      <Table.Tbody>
        <Table.Tr>
          <Table.Td width="5%">
            <ActionIcon
              color="gray"
              variant="transparent"
              onClick={toggle}
            >
              <FontAwesomeIcon
                fixedWidth
                icon={isExpanded ? faMinusSquare : faPlusSquare}
              />
            </ActionIcon>
          </Table.Td>
          <Table.Td colSpan={3}>
            <CustomerLink customer={payment.customer} />
          </Table.Td>
          <Table.Th
            w="10%"
            ta="end"
          >
            {intl.formatMessage({
              id: 'balance',
              defaultMessage: 'Solde'
            })}
            {/* todo show unpaid balance */}
          </Table.Th>
          <Table.Td
            w="10%"
            ta="end"
          >
            <Amount value={payment.balance} colored />
          </Table.Td>
          <Table.Td
            w="10%"
            ta="end"
          >
            {!payment.paid
              ? <ActionIcon
                color="red"
                variant="transparent"
                onClick={toggle}
              >
                <FontAwesomeIcon
                  fixedWidth
                  icon={faExclamationTriangle}
                />
              </ActionIcon>
              : null}
          </Table.Td>
        </Table.Tr>

        {isExpanded
          ? payment.transactions.map((tr) => (
            <Table.Tr key={tr.id}>
              <Table.Td />
              <Table.Td>
                {intl.formatDate(tr.dueAt)}
              </Table.Td>
              <Table.Td>
                <AnchorLink to={getTransactionLink(tr.id, tr.expense)}>
                  {tr.label}
                </AnchorLink>
              </Table.Td>
              <Table.Td>
                {tr.invoiceId
                  ? <AnchorLink to={getInvoiceLink(tr.invoiceId)}>
                    {tr.Invoice.reference}
                  </AnchorLink>
                  : null}
              </Table.Td>
              <Table.Td>
                {tr.leaseId
                  ? <AnchorLink to={getLeaseLink(tr.leaseId)}>
                    {tr.Lease.reference}
                  </AnchorLink>
                  : null}
              </Table.Td>
              <Table.Td ta="end">
                <Amount value={tr.total} />
              </Table.Td>
              <Table.Td ta="end">
                <TransactionStatusBadge transaction={tr} />
              </Table.Td>
            </Table.Tr>
          ))
          : null}
      </Table.Tbody>
    </Table>
  )
}

export default PaymentListItem
